import React, { useState } from "react"
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Container,
    Divider,
    Grid,
    IconButton,
    TextField,
    Typography,
} from "@mui/material"
import { GridExpandMoreIcon } from "@mui/x-data-grid"
import { EventBusy, Vignette } from "@mui/icons-material"
import { useLocation } from "react-router-dom"
import { DateTime } from "luxon"

import ActivityLog from "../../Component/activityLog.jsx"
import useUserPermissions from "../../Hooks/useUserPermissions.js"
import RestrictedAccess from "../../Component/restrictedAccess.jsx"

function PreRIDEProgramDetails() {
    const { programsDetail, activitiesList } = useUserPermissions()
    const [expandedAccord, setExpandedAccord] = useState(false)

    const location = useLocation()

    // ACCESS THE STATE PROP OF THE LINK OBJECT
    const value = location.state

    if (!programsDetail) return <RestrictedAccess />

    return (
        <Container
            maxWidth="false"
            sx={{
                pb: { md: "5em", xs: "1em" },
                pt: { md: "3em" },
                display: "flex",
                flexDirection: { xs: "column", lg: "row" },
            }}
        >
            <Grid
                container
                spacing={1}
                justifyContent="space-around"
                sx={{
                    flex: 2,
                    pt: "1.5em",
                    pl: { xs: 0 },
                }}
            >
                <Grid
                    item
                    xs={12}
                    lg={4}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "1.5em",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: ".5em",
                        }}
                    >
                        <Typography variant="body1" sx={{ fontWeight: "500" }}>
                            Name
                        </Typography>
                        <TextField
                            value={value.name}
                            InputProps={{
                                readOnly: true,
                            }}
                            fullWidth
                        />
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: ".5em",
                        }}
                    >
                        <Typography variant="body1" sx={{ fontWeight: "500" }}>
                            Description
                        </Typography>
                        <TextField
                            value={value?.description}
                            InputProps={{
                                readOnly: true,
                            }}
                            multiline
                            rows={2}
                            fullWidth
                        />
                    </Box>
                </Grid>
                <Grid
                    item
                    xs={12}
                    lg={6}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: ".5em",
                    }}
                >
                    <Typography variant="body1" sx={{ fontWeight: "500" }}>
                        Rule
                    </Typography>
                    <Accordion
                        expanded={expandedAccord === "spending_limit"}
                        onChange={() => {
                            if (expandedAccord === "spending_limit") {
                                setExpandedAccord(false)
                            } else {
                                setExpandedAccord("spending_limit")
                            }
                        }}
                    >
                        <AccordionSummary
                            expandIcon={
                                <GridExpandMoreIcon color="secondary" />
                            }
                        >
                            <Box
                                sx={{
                                    flexGrow: 1,
                                    display: "flex",
                                }}
                            >
                                <IconButton>
                                    <Vignette />
                                </IconButton>
                                <Box>
                                    <Typography
                                        variant="body2"
                                        sx={{ fontWeight: "bold" }}
                                    >
                                        Spending Limit
                                    </Typography>
                                    <Typography>
                                        {/* {(() => {
                                            // const isUnlimited =
                                            //     !value.spending_limit
                                            // return isUnlimited ? (
                                            //     <Typography>
                                            //         No Limit
                                            //     </Typography>
                                            // ) : (
                                            )
                                        })()
                                    } */}
                                        {`${value?.spending_limit_amount} ETB ${value?.spending_limit_duration}`}
                                    </Typography>
                                </Box>
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography variant="subtitle2">
                                spending limit amount
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        value={
                                            value.spending_limit_amount === "0"
                                                ? ""
                                                : value.spending_limit_amount
                                        }
                                        type="number"
                                        InputProps={{
                                            readOnly: true,
                                            inputProps: {
                                                sx: {
                                                    backgroundColor: "white",
                                                    mr: ".5em",
                                                },
                                            },
                                            sx: {
                                                "&.MuiInputBase-root": {
                                                    pr: "0.5em",
                                                    backgroundColor: "#dfdfdf",
                                                },
                                            },
                                            endAdornment: (
                                                <Typography
                                                    sx={{
                                                        backgroundColor:
                                                            "#dfdfdf",
                                                    }}
                                                >
                                                    ETB
                                                </Typography>
                                            ),
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        value={value.spending_limit_duration}
                                    />
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion
                        expanded={expandedAccord === "expire_date"}
                        onChange={() => {
                            if (expandedAccord === "expire_date") {
                                setExpandedAccord(false)
                            } else {
                                setExpandedAccord("expire_date")
                            }
                        }}
                    >
                        <AccordionSummary
                            expandIcon={
                                <GridExpandMoreIcon color="secondary" />
                            }
                        >
                            <Box sx={{ flexGrow: 1, display: "flex" }}>
                                <IconButton>
                                    <EventBusy />
                                </IconButton>
                                <Box>
                                    <Typography
                                        variant="body2"
                                        sx={{ fontWeight: "bold" }}
                                    >
                                        Expire Date
                                    </Typography>
                                    <Typography>
                                        {(() => {
                                            const isUnlimited =
                                                value.has_expire_date === false
                                            return isUnlimited ? (
                                                <Typography>
                                                    No Expire Date
                                                </Typography>
                                            ) : (
                                                DateTime.fromISO(
                                                    value.expire_date
                                                ).toFormat("ff")
                                            )
                                        })()}
                                    </Typography>
                                </Box>
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography variant="body2">expire date</Typography>
                            <TextField
                                InputProps={{
                                    readOnly: true,
                                }}
                                value={
                                    value?.expire_date !==
                                    "0001-01-01T00:00:00Z"
                                        ? DateTime.fromISO(
                                              value.expire_date
                                          ).toFormat("ff")
                                        : null
                                }
                            />
                        </AccordionDetails>
                    </Accordion>
                </Grid>
            </Grid>
            <Divider
                orientation="vertical"
                variant="middle"
                flexItem
                sx={{ width: "10px", color: "gray" }}
            />
            {activitiesList && (
                <Grid sx={{ flex: 1.5, pt: "1.2em" }}>
                    <Typography
                        variant="body1"
                        sx={{ fontWeight: "bold", pb: "0px", pl: "16px" }}
                    >
                        Activity Log
                    </Typography>
                    <Divider variant="middle" sx={{ pb: "1em" }} />
                    <ActivityLog url={`preride/${value?.id}/activities`} />
                </Grid>
            )}
        </Container>
    )
}

export default PreRIDEProgramDetails
